/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_Folders_Load_FailedInputs */

const en_files_folders_load_failed = /** @type {(inputs: Files_Folders_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folders could not be loaded`)
};

const es_files_folders_load_failed = /** @type {(inputs: Files_Folders_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las carpetas`)
};

/**
* | output |
* | --- |
* | "Folders could not be loaded" |
*
* @param {Files_Folders_Load_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_folders_load_failed = /** @type {((inputs?: Files_Folders_Load_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Folders_Load_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_folders_load_failed(inputs)
	return en_files_folders_load_failed(inputs)
});